import { inject, Injectable } from '@angular/core';
import { ServicesService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class InteractionEndpointsService {
  readonly #service = inject(ServicesService);

  public attempt() {
    return this.#service.thor(`attempt`);
  }

  public draft() {
    return this.#service.thor(`draft`);
  }

  public selfScore() {
    return this.#service.thor(`self-score`);
  }

  public close(arrangementCode: string, contentIdentifier: string) {
    return this.#service.thor(
      `attempt/${arrangementCode}/${contentIdentifier}/close`,
    );
  }

  public resultById(arrangementCode: string, contentIdentifier: string) {
    return this.#service.thor(
      `result/content/${arrangementCode}/${contentIdentifier}`,
    );
  }

  public resultAttemptsById(
    arrangementCode: string,
    contentIdentifier: string,
    userIdentifier?: string,
  ) {
    return this.#service.thor(
      `result/content/${arrangementCode}/${contentIdentifier}/${userIdentifier}?allAttempts=true`,
    );
  }

  public clearResultById(arrangementCode: string, contentIdentifier: string) {
    return this.#service.thor(
      `attempt/${arrangementCode}/${contentIdentifier}/all`,
    );
  }

  public progressById(arrangementCode: string, contentIdentifier: string) {
    return this.#service.thor(
      `score/content/${arrangementCode}/${contentIdentifier}`,
    );
  }

  public answerById(arrangementCode: string, contentIdentifier: string) {
    return this.#service.thor(`answer/${arrangementCode}/${contentIdentifier}`);
  }

  public feedbackById(arrangementCode: string, contentPath: string) {
    return this.#service.edition(
      `feedback/arrangement/${arrangementCode}/${contentPath}`,
    );
  }

  public startSelfTest() {
    return this.#service.thor('sequence/start');
  }

  public submitSelfTest() {
    return this.#service.thor('sequence/submit');
  }

  public completeSelfTest() {
    return this.#service.thor('sequence/end');
  }

  public deleteSelfTest() {
    return this.#service.thor('sequence/delete');
  }
}
